
import {
  firebaseFire as Libfirebase
} from '../helpers/firebase-config.js';

export function getVeiculos(idVeiculo = null, secretariaSelecionada, consorcio = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('veiculos');

    if (secretariaSelecionada && secretariaSelecionada.id) {
      ref = ref.where('secretaria', '==', secretariaSelecionada.id);
    }
    if (consorcio) {
      ref = ref.where('consorcio', '==', consorcio);
    }

    if (idVeiculo) {
      ref = ref
        .doc(idVeiculo)
        .get()
        .then(doc => {
          const data = doc.data();

          data.ref = doc.ref;

          resolve(data);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };
          reject(erro);
        });
    } else {
      let list = [];
      ref
        // .orderBy('Nome')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const data = doc.data();

            data.ref = doc.ref;

            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export async function deleteVeiculo(ref) {
  return await ref.update({
    ativo: false
  });
}

export function setVeiculo(data) {
  return new Promise(function (resolve, reject) {
    data.ref ?
      data.ref
        .set(data)
        .then(() => resolve(true))
        .catch(error => {
          const erro = {
            error,
            msg:
              'Houve um problema ao cadastrar o Veículo, favor tentar novamente'
          };
          reject(erro);
        })
      : Libfirebase.collection('veiculos')
        .add(data)
        .then(() => resolve(true))
        .catch(error => {
          const erro = {
            error,
            msg:
              'Houve um problema ao cadastrar o Veículo, favor tentar novamente'
          };
          reject(erro);
        });
  });
}

export function getVeiculoById(id) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('veiculos')
      .doc(id)
      .get()
      .then(doc => {
        var data = doc.data();
        data.ref = doc.ref;
        resolve(data);
      })
      .catch(error => {
        const erro = {
          error,
          msg:
            'Houve um problema para buscar os veículos, favor tentar novamente'
        };
        reject(erro);
      });
  });
}